module.exports = __webpack_public_path__ + "static/media/file.9eeac619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/file.jpg
// module id = 279
// module chunks = 2